import React from 'react'
import './Work.css'
import Works from './Works'
function Work() {
  return (
    <section className="work section" id="portfolio">
        <h2 className="section-title">Projects</h2>
        <span className="section-subtitle">More Resently Work</span>
        <Works/>
    </section>
  )
}

export default Work
